import { useParams } from '@tanstack/react-router';
import QRAccessLanding from '@/components/access/QRAccessLanding';

const GuestAccessPage = () => {
	const { propertyPublicId } = useParams({ from: '/property/$propertyPublicId/guest-access' });
	return <QRAccessLanding propertyPublicId={propertyPublicId} />;
};

export const Route = createFileRoute({
	component: GuestAccessPage,
});
